(function () {
  'use strict';
  var legacySizes = [44, 45, 46.5, 47.5, 49, 50, 52, 53, 54, 55, 57, 58, 59.5, 60];
  // Approximate US conversion, interpolated from Tiffany's published mm chart.
  // https://www.tiffany.fr/client-services/size-guide.html
  var usCircumferences = [44.2, 45.5, 46.8, 48.0, 49.3, 50.6, 51.9, 53.1, 54.4, 55.7, 57.0, 58.3, 59.5, 60.8, 62.1, 63.4, 64.6, 65.9, 67.2, 68.5, 69.7];
  function approximateUsSize(euSize) {
    var i = 0;
    while (i < usCircumferences.length - 2 && euSize > usCircumferences[i + 1]) i++;
    var value = 3 + i * 0.5 + (euSize - usCircumferences[i]) /
      (usCircumferences[i + 1] - usCircumferences[i]) * 0.5;
    return String(Math.round(value * 4 + 1e-9) / 4);
  }
  var options = [];
  for (var halfSize = 86; halfSize <= 140; halfSize++) {
    var size = halfSize / 2;
    var legacyIndex = legacySizes.indexOf(size);
    options.push({
      id: legacyIndex >= 0 ? legacyIndex + 1 : 'eu-' + size,
      european_size: String(size),
      circumference_mm: String(size),
      us_canada: approximateUsSize(size),
      diameter_mm: (size / Math.PI).toFixed(2),
      popular: size >= 48 && size <= 56 && size % 1 === 0
    });
  }
  window.JoolmeRingSizes = {
    options: function () { return options.map(function (size) { return Object.assign({}, size); }); }
  };
  window.JoolmeRingSizesMixin = {
    data: function () { return { showMoreRingSizes: false, ringSizesCanScroll: true, ringSizesInline: false }; },
    mounted: function () {
      this._ringSizeMedia = window.matchMedia('(min-width: 992px)');
      this._ringSizeMediaChanged = this.syncRingSizePanel.bind(this);
      this._ringSizeMedia.addEventListener('change', this._ringSizeMediaChanged);
      this.syncRingSizePanel();
    },
    beforeDestroy: function () {
      this._ringSizeMedia.removeEventListener('change', this._ringSizeMediaChanged);
    },
    watch: {
      sizeProduct: function (value) {
        if (value && !this.sizeOfProductData.some(function (size) { return String(size.id) === String(value); })) {
          this.sizeProduct = '';
        }
      },
      showMoreRingSizes: function (open) {
        this.syncRingSizePanel();
        if (!open) this.$nextTick(function () { this.$refs.ringSizeToggle.focus(); });
      }
    },
    methods: {
      syncRingSizePanel: function () {
        var inline = this.$el.id === 'productApp' && this._ringSizeMedia.matches;
        this.ringSizesInline = inline;
        this.$nextTick(function () {
          var dialog = this.$refs.ringSizeDialog;
          if (!dialog) return;
          if (this.showMoreRingSizes) {
            if (inline || !dialog.open) {
              if (!inline) dialog.showModal();
              var grid = this.$refs.ringSizeGrid;
              var input = grid && (grid.querySelector('input:checked') || grid.querySelector('input[value="eu-48"]'));
              if (input) {
                var label = input.closest('label');
                grid.scrollTop = Math.max(0, label.offsetTop - grid.offsetTop - (grid.clientHeight - label.offsetHeight) / 2);
              }
            }
            this.updateRingSizeScroll();
          } else if (!inline && dialog.open) dialog.close();
        });
      },
      handleRingSizeDialogClose: function () {
        if (!this.$refs.ringSizeDialog.open) this.showMoreRingSizes = false;
      },
      scrollMoreRingSizes: function () {
        var grid = this.$refs.ringSizeGrid;
        if (grid) grid.scrollBy({ top: Math.max(80, grid.clientHeight * 0.75), behavior: 'smooth' });
      },
      updateRingSizeScroll: function (event) {
        var grid = event && event.target || this.$refs.ringSizeGrid;
        if (grid) this.ringSizesCanScroll = grid.scrollHeight - grid.clientHeight - grid.scrollTop > 4;
      }
    },
    computed: {
      selectedExtraRingSize: function () {
        var selected = String(this.sizeProduct);
        return this.sizeOfProductData.find(function (size) { return !size.popular && String(size.id) === selected; });
      },
      visibleRingSizes: function () {
        return this.sizeOfProductData.filter(function (size) { return size.popular; });
      }
    }
  };
})();
